import { CANCEL, SHOW_FORM, SUBMIT } from './action-types.js';

export function showFormDialog({ formName, title, instructions, submitLabel, initialData, schema, config, callback }) {
  return {
    type: SHOW_FORM,
    meta: {
      callback
    },
    payload: {
      title,
      schema,
      config,
      formName,
      initialData,
      instructions,
      submitLabel
    }
  };
}

export function cancel() {
  return { type: CANCEL };
}

export function submitFormDialog(formData) {
  return {
    type: SUBMIT,
    payload: {
      formData
    }
  };
}
